import { supabase } from './supabase';

// Same-error-per-session dedup — a render loop or repeated failed poll could otherwise
// flood error_log with hundreds of identical rows from one visitor in seconds.
const loggedThisSession = new Set<string>();

export function logClientError(message: string, stack?: string | null) {
  const key = message.slice(0, 200);
  if (loggedThisSession.has(key)) return;
  loggedThisSession.add(key);

  supabase.from('error_log').insert({
    source: 'frontend',
    message: message.slice(0, 2000),
    stack: stack ? stack.slice(0, 4000) : null,
    url: typeof window !== 'undefined' ? window.location.href : null,
  }).then(({ error }) => {
    if (error) console.error('logClientError failed:', error);
  });
}

// Catches errors React's own render-tree ErrorBoundary can't see: async code,
// event handlers, timers, and rejected promises that nobody awaited.
export function installGlobalErrorLogging() {
  window.addEventListener('error', (event) => {
    logClientError(event.message || 'Unknown window error', event.error?.stack);
  });
  window.addEventListener('unhandledrejection', (event) => {
    const reason: any = event.reason;
    logClientError(
      reason?.message ? String(reason.message) : String(reason ?? 'Unhandled promise rejection'),
      reason?.stack
    );
  });
}
